<div class="action-container">
<button class="delete-row" (click)="onDeleteRow()">
  <i class="fa fa-trash-o "></i>
</button>
</div>
